import { Checkbox } from '@chakra-ui/react';
import { Cart } from '@diamond/shared/types';
import { useCartStore } from '@diamond/sol-buyer-context';
import { ChangeEvent } from 'react';

type CartSelectAllProps = { items: Array<Cart> };

export function CartSelectAll({ items }: CartSelectAllProps) {
  const cartItems = useCartStore((s) => s.cartItems);
  const reset = useCartStore((s) => s.reset);

  const handleCheckAll = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      const storeState = useCartStore.getState();
      const hydratedItems = items.map((item) => {
        const existingEntry = storeState.cartRecord[item.id];
        if (!existingEntry) {
          return item;
        }
        return {
          ...item,
          quantity: existingEntry.quantity,
        };
      });
      reset(hydratedItems);
    } else {
      reset([]);
    }
  };

  return (
    <Checkbox
      onChange={(e) => handleCheckAll(e)}
      isChecked={cartItems.length === items.length && cartItems.length > 0}
      isDisabled={items.length === 0}
      id="select-all"
      size={{ base: 'md', lg: 'lg' }}
      colorScheme="blue"
    >
      Pilih Semua
    </Checkbox>
  );
}
